var map = {
	"./countries/abkhazia.svg": 36881,
	"./countries/afghanistan.svg": 81064,
	"./countries/aland-islands.svg": 42085,
	"./countries/albania.svg": 95406,
	"./countries/algeria.svg": 74035,
	"./countries/american-samoa.svg": 85574,
	"./countries/andorra.svg": 69041,
	"./countries/angola.svg": 46796,
	"./countries/anguilla.svg": 58297,
	"./countries/antigua-and-barbuda.svg": 60381,
	"./countries/argentina.svg": 75933,
	"./countries/armenia.svg": 96459,
	"./countries/aruba.svg": 5659,
	"./countries/australia.svg": 39004,
	"./countries/austria.svg": 83975,
	"./countries/azerbaijan.svg": 73689,
	"./countries/azores-islands.svg": 26273,
	"./countries/bahamas.svg": 88209,
	"./countries/bahrain.svg": 14613,
	"./countries/balearic-islands.svg": 86176,
	"./countries/bangladesh.svg": 53373,
	"./countries/barbados.svg": 71096,
	"./countries/basque-country.svg": 41982,
	"./countries/belarus.svg": 76402,
	"./countries/belgium.svg": 79673,
	"./countries/belize.svg": 46235,
	"./countries/benin.svg": 88544,
	"./countries/bermuda.svg": 63206,
	"./countries/bhutan-1.svg": 4183,
	"./countries/bhutan.svg": 57566,
	"./countries/bolivia.svg": 51602,
	"./countries/bonaire.svg": 69630,
	"./countries/bosnia-and-herzegovina.svg": 44233,
	"./countries/botswana.svg": 3991,
	"./countries/brazil.svg": 75712,
	"./countries/british-columbia.svg": 11564,
	"./countries/british-indian-ocean-territory.svg": 99233,
	"./countries/british-virgin-islands.svg": 49782,
	"./countries/brunei.svg": 22025,
	"./countries/bulgaria.svg": 76065,
	"./countries/burkina-faso.svg": 36570,
	"./countries/burundi.svg": 93077,
	"./countries/cambodia.svg": 74416,
	"./countries/cameroon.svg": 9654,
	"./countries/canada.svg": 77604,
	"./countries/canary-islands.svg": 12883,
	"./countries/cape-verde.svg": 51318,
	"./countries/cayman-islands.svg": 40952,
	"./countries/central-african-republic.svg": 50391,
	"./countries/ceuta.svg": 68482,
	"./countries/chad.svg": 64252,
	"./countries/chile.svg": 50377,
	"./countries/china.svg": 66083,
	"./countries/christmas-island.svg": 89132,
	"./countries/cocos-island.svg": 97897,
	"./countries/colombia.svg": 13436,
	"./countries/comoros.svg": 10420,
	"./countries/cook-islands.svg": 95915,
	"./countries/corsica.svg": 71214,
	"./countries/costa-rica.svg": 67176,
	"./countries/croatia.svg": 58921,
	"./countries/cuba.svg": 13809,
	"./countries/curacao.svg": 35348,
	"./countries/cyprus.svg": 8460,
	"./countries/czech-republic.svg": 17224,
	"./countries/democratic-republic-of-congo.svg": 67743,
	"./countries/denmark.svg": 77860,
	"./countries/djibouti.svg": 92420,
	"./countries/dominica.svg": 87152,
	"./countries/dominican-republic.svg": 66507,
	"./countries/east-timor.svg": 44851,
	"./countries/ecuador.svg": 18351,
	"./countries/egypt.svg": 86291,
	"./countries/england.svg": 59961,
	"./countries/equatorial-guinea.svg": 52397,
	"./countries/eritrea.svg": 71688,
	"./countries/estonia.svg": 81439,
	"./countries/ethiopia.svg": 99571,
	"./countries/european-union.svg": 23755,
	"./countries/falkland-islands.svg": 80448,
	"./countries/faroe-islands.svg": 66416,
	"./countries/fiji.svg": 74590,
	"./countries/finland.svg": 43722,
	"./countries/france.svg": 49015,
	"./countries/french-polynesia.svg": 31111,
	"./countries/french-southern-territories.svg": 12590,
	"./countries/gabon.svg": 40123,
	"./countries/galapagos-islands.svg": 80118,
	"./countries/gambia.svg": 4173,
	"./countries/georgia.svg": 29302,
	"./countries/germany.svg": 94537,
	"./countries/ghana.svg": 95679,
	"./countries/gibraltar.svg": 58942,
	"./countries/greece.svg": 75723,
	"./countries/greenland.svg": 3180,
	"./countries/grenada.svg": 45988,
	"./countries/guam.svg": 38672,
	"./countries/guatemala.svg": 4241,
	"./countries/guernsey.svg": 85732,
	"./countries/guinea-bissau.svg": 26622,
	"./countries/guinea.svg": 68501,
	"./countries/guyana.svg": 28143,
	"./countries/haiti.svg": 66849,
	"./countries/hawaii.svg": 69453,
	"./countries/honduras.svg": 46362,
	"./countries/hong-kong.svg": 99306,
	"./countries/hungary.svg": 18732,
	"./countries/iceland.svg": 3736,
	"./countries/india.svg": 63375,
	"./countries/indonesia.svg": 55148,
	"./countries/iran.svg": 99358,
	"./countries/iraq.svg": 86057,
	"./countries/ireland.svg": 50635,
	"./countries/isle-of-man.svg": 82124,
	"./countries/israel.svg": 61034,
	"./countries/italy.svg": 8907,
	"./countries/ivory-coast.svg": 14004,
	"./countries/jamaica.svg": 40136,
	"./countries/japan.svg": 96710,
	"./countries/jersey.svg": 90714,
	"./countries/jordan.svg": 81272,
	"./countries/kazakhstan.svg": 45544,
	"./countries/kenya.svg": 28310,
	"./countries/kiribati.svg": 85307,
	"./countries/kosovo.svg": 88215,
	"./countries/kuwait.svg": 89245,
	"./countries/kyrgyzstan.svg": 16598,
	"./countries/laos.svg": 6617,
	"./countries/latvia.svg": 21967,
	"./countries/lebanon.svg": 30133,
	"./countries/lesotho.svg": 79212,
	"./countries/liberia.svg": 78664,
	"./countries/libya.svg": 69945,
	"./countries/liechtenstein.svg": 60921,
	"./countries/lithuania.svg": 65763,
	"./countries/luxembourg.svg": 53978,
	"./countries/macao.svg": 62291,
	"./countries/macedonia.svg": 94493,
	"./countries/madagascar.svg": 33662,
	"./countries/madeira.svg": 83521,
	"./countries/malawi.svg": 57957,
	"./countries/malaysia.svg": 74915,
	"./countries/maldives.svg": 42161,
	"./countries/mali.svg": 17601,
	"./countries/malta.svg": 43117,
	"./countries/marshall-island.svg": 59258,
	"./countries/martinique.svg": 58883,
	"./countries/mauritania.svg": 72449,
	"./countries/mauritius.svg": 37155,
	"./countries/melilla.svg": 550,
	"./countries/mexico.svg": 62735,
	"./countries/micronesia.svg": 27350,
	"./countries/moldova.svg": 24182,
	"./countries/monaco.svg": 78719,
	"./countries/mongolia.svg": 44060,
	"./countries/montenegro.svg": 29908,
	"./countries/montserrat.svg": 61187,
	"./countries/morocco.svg": 61144,
	"./countries/mozambique.svg": 18072,
	"./countries/myanmar.svg": 95835,
	"./countries/namibia.svg": 85701,
	"./countries/nato.svg": 19814,
	"./countries/nauru.svg": 19185,
	"./countries/nepal.svg": 59196,
	"./countries/netherlands-antilles.svg": 84903,
	"./countries/netherlands.svg": 31946,
	"./countries/new-zealand.svg": 87904,
	"./countries/nicaragua.svg": 9423,
	"./countries/niger.svg": 25029,
	"./countries/nigeria.svg": 16667,
	"./countries/niue.svg": 99715,
	"./countries/norfolk-island.svg": 53569,
	"./countries/north-korea.svg": 6942,
	"./countries/northen-cyprus.svg": 81737,
	"./countries/northern-marianas-islands.svg": 33800,
	"./countries/norway.svg": 74280,
	"./countries/oman.svg": 82963,
	"./countries/orkney-islands.svg": 9917,
	"./countries/ossetia.svg": 59374,
	"./countries/pakistan.svg": 78547,
	"./countries/palau.svg": 73547,
	"./countries/palestine.svg": 5571,
	"./countries/panama.svg": 28750,
	"./countries/papua-new-guinea.svg": 3000,
	"./countries/paraguay.svg": 5526,
	"./countries/peru.svg": 93900,
	"./countries/philippines.svg": 63243,
	"./countries/pitcairn-islands.svg": 65251,
	"./countries/portugal.svg": 31192,
	"./countries/puerto-rico.svg": 77363,
	"./countries/qatar.svg": 81045,
	"./countries/rapa-nui.svg": 44715,
	"./countries/republic-of-macedonia.svg": 84892,
	"./countries/republic-of-poland.svg": 87509,
	"./countries/republic-of-the-congo.svg": 62251,
	"./countries/romania.svg": 89627,
	"./countries/russia.svg": 66605,
	"./countries/rwanda.svg": 62895,
	"./countries/saba-island.svg": 32217,
	"./countries/saint-kitts-and-nevis.svg": 53777,
	"./countries/salvador.svg": 972,
	"./countries/samoa.svg": 55659,
	"./countries/san-marino.svg": 87457,
	"./countries/sao-tome-and-principe.svg": 89538,
	"./countries/sardinia.svg": 44123,
	"./countries/saudi-arabia.svg": 52321,
	"./countries/scotland.svg": 85266,
	"./countries/senegal.svg": 30507,
	"./countries/serbia.svg": 64900,
	"./countries/seychelles.svg": 45979,
	"./countries/sierra-leone.svg": 98176,
	"./countries/singapore.svg": 8868,
	"./countries/sint-eustatius.svg": 93350,
	"./countries/sint-maarten.svg": 90527,
	"./countries/slovakia.svg": 21986,
	"./countries/slovenia.svg": 58103,
	"./countries/solomon-islands.svg": 58330,
	"./countries/somalia.svg": 25140,
	"./countries/somaliland.svg": 26068,
	"./countries/south-africa.svg": 89768,
	"./countries/south-korea.svg": 53384,
	"./countries/south-sudan.svg": 55643,
	"./countries/spain.svg": 97525,
	"./countries/sri-lanka.svg": 86380,
	"./countries/st-barts.svg": 24712,
	"./countries/st-lucia.svg": 8578,
	"./countries/st-vincent-and-the-grenadines.svg": 31088,
	"./countries/sudan.svg": 85039,
	"./countries/suriname.svg": 10832,
	"./countries/swaziland.svg": 80417,
	"./countries/sweden.svg": 55758,
	"./countries/switzerland.svg": 49169,
	"./countries/syria.svg": 54974,
	"./countries/taiwan.svg": 75858,
	"./countries/tajikistan.svg": 57372,
	"./countries/tanzania.svg": 84700,
	"./countries/thailand.svg": 95747,
	"./countries/tibet.svg": 45856,
	"./countries/togo.svg": 45079,
	"./countries/tokelau.svg": 24769,
	"./countries/tonga.svg": 8461,
	"./countries/transnistria.svg": 50290,
	"./countries/trinidad-and-tobago.svg": 57780,
	"./countries/tunisia.svg": 61113,
	"./countries/turkey.svg": 69564,
	"./countries/turkmenistan.svg": 40963,
	"./countries/turks-and-caicos.svg": 7196,
	"./countries/tuvalu.svg": 16297,
	"./countries/uganda.svg": 63558,
	"./countries/ukraine.svg": 13653,
	"./countries/united-arab-emirates.svg": 78685,
	"./countries/united-kingdom.svg": 42503,
	"./countries/united-nations.svg": 68736,
	"./countries/united-states-of-america.svg": 84283,
	"./countries/uruguay.svg": 32554,
	"./countries/uzbekistn.svg": 74585,
	"./countries/vanuatu.svg": 61530,
	"./countries/vatican-city.svg": 71030,
	"./countries/venezuela.svg": 31523,
	"./countries/vietnam.svg": 2422,
	"./countries/virgin-islands.svg": 88096,
	"./countries/wales.svg": 32350,
	"./countries/western-sahara.svg": 94263,
	"./countries/yemen.svg": 16724,
	"./countries/zambia.svg": 90810,
	"./countries/zimbabwe.svg": 27985
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 36747;
module.exports = webpackAsyncContext;